<div class="pdf-container">
  @if (url) {
    <iframe [src]="url"></iframe>
  }
</div>
